module.exports = __webpack_public_path__ + "img/MBT_3.54dd7d8c.svg";